import { Injectable } from '@angular/core';

import { SpinnerState } from './spinner';
import { Subject } from 'rxjs';

@Injectable()

export class SpinnerService {

    spinnerSubject = new Subject<SpinnerState>();

    // loaderState = this.spinnerSubject.asObservable();

    constructor() { }

    show() {
        // document.getElementById("overlayBody").classList.add("overlay");
        // document.getElementById("appAngularSpinner").style.display = "block";
        this.spinnerSubject.next(<SpinnerState>{show: true});
    }

    hide() {
        // document.getElementById("overlayBody").classList.remove("overlay");
        // document.getElementById("appAngularSpinner").style.display = "none";
        this.spinnerSubject.next(<SpinnerState>{show: false});
        // this.spinnerSubject.next();
    }
}